import React, { useEffect, useRef, useState } from "react";
import { Button, Container, Form, Image } from "react-bootstrap";
import { UserWithPasswordFields } from "@/pages";
import { formatPhone } from "@/shared/ui";
import { getfile } from "@/entities/message";

interface ProfileViewProps {
  user: UserWithPasswordFields;
  onEdit: () => void;
}

export const ProfileView: React.FC<ProfileViewProps> = ({ user, onEdit }) => {

  const containerRef = useRef<HTMLDivElement>(null);
  
  const [file, setFile] = useState(user.avatarUrl)

  useEffect(() => {
    if (user.avatarUrl) {
      getfile(user.avatarUrl)
        .then((data) => {
          const objectUrl = URL.createObjectURL(data);
          setFile(objectUrl);

          return () => {
            URL.revokeObjectURL(objectUrl);
          };
        })
        .catch((error) => {
          console.error("Error loading avatar:", error);
        });
    }
  }, [user.avatarUrl]);

  return (
    <Container className="mt-4 px-4" style={{ maxWidth: 600 }}>
      <h2>Профиль</h2>
      <div  
        ref={containerRef}
        className="my-4 d-flex justify-content-md-start justify-content-center">
        {file ? (
          <Image
            src={file}
            roundedCircle
            width={100}
            height={100}
            style={{ objectFit: "cover" }}
          />
        ) : (
          <div
            style={{
              width: 100,
              height: 100,
              borderRadius: "50%",
              backgroundColor: "#6c757d",
              color: "white",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontWeight: "bold",
              fontSize: 40,
            }}
          >
            {user.firstName?.[0]?.toUpperCase() || "?"}
          </div>
        )}
      </div>
      <div className="mb-3">
        <Form.Label className="text-secondary">Имя</Form.Label>
        <div>{user.firstName || "—"}</div>
      </div>
      <div className="mb-3">
        <Form.Label className="text-secondary">Фамилия</Form.Label>
        <div>{user.lastName || "—"}</div>
      </div>
      <div className="mb-3">
        <Form.Label className="text-secondary">Телефон</Form.Label>
        <div>{formatPhone(user.phone) || "—"}</div>
      </div>
      <Button variant="outline-secondary" onClick={onEdit} type="button" className="mt-3">
        Редактировать профиль
      </Button>
    </Container>
  );
};
